export default __webpack_public_path__ + "static/media/logo.7e6d65e2.png";